import { X } from "lucide-react";

const ProblemaSection = () => {
  const problems = [
    "\"Szép lett\", de nem mondja el tisztán, mi az ajánlat",
    "Túl sok mindent akar egyszerre → szétesik a figyelem",
    "Nincs igazi CTA → a látogató csak nézelődik és kilép",
    "\"Mi bemutatkozunk\" jellegű → nem a vevő kérdéseire válaszol",
    "Mobilon túl hosszú vagy átláthatatlan → elvérzik a legfontosabb felületen",
    "Nincs bizalomépítés → a látogató nem mer lépni"
  ];

  return (
    <section data-testid="problema-section" className="light-band-2 py-20 md:py-28 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div>
          <h2 className="scroll-animate font-sora font-bold text-3xl sm:text-4xl lg:text-5xl text-ink-text text-center">
            A legtöbb weboldal nem rossz —{" "}
            <span className="text-spark">csak nem céltudatos.</span>
          </h2>

          <div className="scroll-animate-stagger scroll-animate grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-12">
            {problems.map((problem, i) => (
              <div
                key={i}
                className="card-light rounded-2xl p-6 flex items-start gap-4 hover:-translate-y-1 transition-transform"
              >
                <div className="w-8 h-8 rounded-full bg-spark/10 flex items-center justify-center flex-shrink-0">
                  <X size={16} className="text-spark" />
                </div>
                <p className="text-ink-text/80">{problem}</p>
              </div>
            ))}
          </div>

          {/* Quote spotlight */}
          <div className="scroll-animate mt-12 relative">
            <div className="bg-gradient-to-r from-primary/5 via-accent/5 to-spark/5 rounded-3xl p-8 md:p-12 text-center border border-primary/10">
              <p className="font-sora text-xl md:text-2xl text-ink-text font-medium leading-relaxed max-ch-65 mx-auto">
                "Egy weboldal feladata nem az, hogy elmondjon mindent — hanem hogy elindítson egy kapcsolatot."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemaSection;
